export default __webpack_public_path__ + "static/media/zdh_web_01.4fda05f4.webp";